import * as types from "./types";

const INITIAL_STATE = {
  lang: localStorage.getItem("lang") || "en"
};

const locale = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_CURRENT_LANG:
      return { ...state, lang: action.lang };
    default:
      return state;
  }
};

export default locale;
